import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import initialState from "./initial";
import { updateObjectState } from "../utils";
import moment from "moment";
import log from "../../utils/log";

const useAuthStore = create(
  persist(
    immer((set, get) => ({
      ...initialState, // Spread the initial state
      updateAuth: ({ passed, jwt, role } = {}) => {
        // Ensure jwt is provided when authentication is passed
        if (passed && (!jwt || !role)) {
          throw new Error("JWT / role must be provided when authentication is passed");
        }

        // Create a new auth object
        let newAuth = !passed
          ? { passed: false }
          : {
              passed: true,
              jwt,
              role,
              expiryAt: moment().add(1, "days").toISOString(),
            };

        return set({ auth: newAuth });
      },
      updateUser: (action, param) => set({ user: updateObjectState(get().user, action, param) }),
      updateIsResetTwoFa: (isReset) => set({ isResetTwoFa: isReset }),
      resetAuth: () => set(initialState), // Reset function
    })),
    {
      name: "pearl-auth", //name of store, must be unique
      //storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    }
  )
);

export default useAuthStore;
